<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          color="primary"
          class="ma-3"
          :to="zoznamUrl"
        >Zoznam klientov</v-btn>
      </v-col>
    </v-row>
    <socialny-podnik-profile
      :item="item"
      :editable="true"
    />
  </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import session from '@/api/session';

import SocialnyPodnikProfile from './components/SocialnyPodnikProfile.vue';

const apiService = new APIService();

export default {
  components: {
    SocialnyPodnikProfile
  },

  data: function () {
    return {
      item: {}
    }
  },

  computed: {
    zoznamUrl() {
      return `/socialne_podniky/${this.$route.params.token}/`;
    }
  },

  mounted() {
    if (this.$route.params.token)
      session.defaults.headers.Authorization = `Token ${this.$route.params.token}`;

    this.getItem();
  },

  methods: {
    getItem() {
      apiService.meSocialnyPodnikUser().then((response) => {
        this.item = response;
      });
    },
  }
}
</script>
